import { Warehouse } from '../types';

export const MOCK_WAREHOUSES: readonly Warehouse[] = [
  {
    id: '1',
    name: 'Основной склад',
    address: 'г. Бишкек, ул. Промышленная 15',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '2',
    name: 'Холодильный склад',
    address: 'г. Бишкек, ул. Промышленная 17',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  }
] as const;
